export default "__VITE_ASSET__BDGQXxCk__"